/* eslint-disable */
import anime from 'animejs';

export default {
  init() {
    // scripts here run on the DOM load event
  },
  finalize() {


    $( ".graphics-show-more" ).click(function(event) {

      event.preventDefault();

      let currentInfoGraphicComponent = $(this.parentNode.parentNode.parentNode); //jquery obj
      let allInfoGraphics =  $( currentInfoGraphicComponent ).find( ".graphic-item" );

      var counter = 0;
      allInfoGraphics.each(function() {

        if ($(this).hasClass( "hidden" )) {
            counter++;
            if(counter <= 6){
              $(this).removeClass( "hidden" );
            }
        }
      });

      if(allInfoGraphics.not(".hidden").length == allInfoGraphics.length) {

          $(this).hide();
      }



    });


  },
};



// WEBPACK FOOTER //
// ./scripts/components/info-graphics.js